<template>
    <div class="col-sm-12 nopads">
        <form class="col-sm-12 editor-form">
            <h2 class="editor-header px-1" v-if="equipment.id > 0">
                {{ $t('areas.equipment_edit') }}
            </h2>
            <h2 class="editor-header px-1" v-else>
                {{ $t('areas.equipment_add') }}
            </h2>
            <div class="col-sm-12">
                <h4 class="form-header">{{ $t('power_stations.basic_info')}}</h4>
                <area-filter
                    class="ml-1"
                    ref="areaFilter"
                    :no-geom="true"
                    :equipment="jsonToEquipment(equipmentUpdate)"
                    @areaSet="setArea"
                />
                <!-- Equipment name -->
                <span class="span-title">
                  {{ $t('equipment.name') }} ( {{ equipmentUpdate.name ? equipmentUpdate.name.length : '0'}} / 100)
                </span>
                <input
                    id="equipment_name"
                    v-model="equipmentUpdate.name"
                    type="text"
                    class="form-control form-control-sm"
                    :maxlength="100"
                />

                <span class="span-title">{{ $t('equipment.type') }}</span>
                <select
                    id="equipment_type"
                    v-model="equipmentUpdate.type"
                    class="form-select form-select-sm sm-3"
                >
                    <option value="null">
                        {{ $t('equipment.select_equipment_type') }}
                    </option>
                    <option value="1">
                        {{ getEquipmentType(1) }}
                    </option>
                    <option value="2">
                        {{ getEquipmentType(2) }}
                    </option>
                    <option value="3">
                        {{ getEquipmentType(3) }}
                    </option>
                    <option value="4">
                        {{ getEquipmentType(4) }}
                    </option>
                </select>

                <!-- Equipment description -->
                <span class="span-title">
                      {{ $t('equipment.description') }} ( {{ equipmentUpdate.description ? equipmentUpdate.description.length : '0'}} / 250)
                </span>
                <input
                    id="equipment_description"
                    v-model="equipmentUpdate.description"
                    class="form-select form-select-sm"
                    type="text"
                    :maxlength="250"
                />

                <!-- Equipment manufacturer -->
                <span class="span-title">
                      {{ $t('equipment.manufacturer') }} ( {{ equipmentUpdate.manufacturer ? equipmentUpdate.manufacturer.length : '0'}} / 100)
                </span>
                <input
                    id="equipment_manufacturer"
                    v-model="equipmentUpdate.manufacturer"
                    class="form-select form-select-sm"
                    type="text"
                    :maxlength="100"
                />
                <span class="span-title">{{ $t('inspection_editor.inactive') }}</span>
                <div class="form-check pt-1">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="in_active"
                        v-model="equipmentUpdate.is_inactive"
                    />
                    <label class="form-check-label ms-2" for="generateExternalReports">
                        {{ $t('inspection_editor.inactive') }}
                    </label>
                </div>
                <hr/>
                <!-- Equipment location -->
                <h4 class="form-header">{{ $t('areas.location')}}</h4>
                <div class="row">
                    <div class="col-sm-6">
                        <input
                            id="latitude"
                            v-model="equipmentUpdate.location.y"
                            type="number"
                            class="form-control form-control-sm my-1"
                            step="0.0000000000001"
                            placeholder="Latitude"
                        />
                        <input
                            id="longitude"
                            v-model="equipmentUpdate.location.x"
                            type="number"
                            class="form-control form-control-sm my-1"
                            step="0.0000000000001"
                            placeholder="Longitude"
                        />
                        <div class="col-12 text-end">
                            <button
                                :disabled="fetchingLocation"
                                class="form-button btn btn-info"
                                @click.stop="setCurrentLocation"
                            >
                                <span class="map-button-text">
                                  {{ $t('common.get_location') }}
                                </span>
                            </button>
                            <span
                                v-if="fetchingLocation"
                                class="span-title blink"
                            >
                            {{ $t('common.fetching_location') }}
                        </span>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="area-map-row item-map stat-container px-0" style="overflow: hidden">
                            <div class="map-container" style="min-height: 15em; position: relative">
                                <map-container
                                    ref="equipmentMap"
                                    :find-user="equipmentUpdate.id < 1"
                                    @onDragEnd="updateLocation"
                                    @onMapClicked="setLocation"
                                    @onMapChanged="init"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <hr/>
                <!-- Equipment photo -->
                <h4 class="form-header">{{ $t('area_report_details.photos')}}</h4>
                <div class="col-12">
                    <!-- Hidden file input -->
                    <input
                        type="file"
                        class="d-none"
                        id="photo"
                        accept="gt, csv"
                        @change="onFileChange"
                        ref="fileInput"
                    />
                    <span class="flex-grow-1">{{ equipmentPhotoFile ? equipmentPhotoFile.name :  '' }}</span>
                    <div class="col-12 area-img-container text-center">
                        <image-view
                            v-if="equipmentPhotoUrl"
                            :url="equipmentPhotoUrl"
                            :file="equipmentPhotoFile"
                            :img-size="'lg'"
                        />
                    </div>
                </div>

                <div class="col-sm-12 mt-3 text-end">
                    <button
                        type="button"
                        class="btn btn-outline-primary form-button"
                        @click="triggerFileInput"
                    >
                        {{ $t('common.add_photo') }}
                    </button>
                    <button class="form-button btn btn-danger" @click.stop="$emit('close')">
                        {{ $t('common.cancel') }}
                    </button>
                    <button class="form-button btn btn-success" :disabled="loading" @click.stop="submitEquipment">
                        {{ $t('common.save') }}
                    </button>
                </div>
            </div>
        </form>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {areaHelper} from '../../mixins/AreaMixin'
import {restApi} from '../../mixins/RestApiMixin'
import AreaFilter from '../AreaFilter'
import ImageView from '../../view/ImageView'
import MapContainer from "../../map/MapContainer";
import {mapHelper} from "@/components/mixins/MapMixin";
import {isPointInPolygon} from "geolib";
import {areaReportHelper} from "@/components/mixins/AreaReportMixin";
import {inject} from "vue";

export default {
    name: 'EquipmentEditor',
    components: {MapContainer, AreaFilter, ImageView},
    mixins: [areaHelper, restApi, mapHelper, areaReportHelper],
    props: {
        equipment: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            area: null,
            fetchingLocation: false,
            areaId: '',
            equipmentPhotoFile: null,
            equipmentPhotoUrl: null,
            equipmentUpdate: this.jsonToEquipment(this.equipment),
            selectedArea: null
        }
    },
    watch: {
        'equipmentUpdate.location': {
            handler: function () {
                this.$refs.equipmentMap.getMap().removeMapMarker(this.equipmentUpdate.id, this.EQUIPMENT)
                this.$refs.equipmentMap.getMap().addDraggableEquipmentMarker(this.equipmentUpdate)
            },
            deep: true
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.init();
        })
    },
    methods: {
        async init() {
            if (!this.$refs.equipmentMap.getMap()) return;
            if (this.equipmentUpdate !== null && this.equipmentUpdate.photos && this.equipmentUpdate.photos.length) {
                var photoId = this.equipmentUpdate.photos[this.equipmentUpdate.photos.length - 1].id
                if (photoId !== null) {
                    this.equipmentPhotoUrl = this.areaEquipmentPhotoUrl + this.equipmentUpdate.id + '/' + photoId
                }
            }
            if (this.equipmentUpdate && this.equipmentUpdate.location && this.equipmentUpdate.location.y && this.equipmentUpdate.location.x) {
                this.$refs.equipmentMap.getMap().addDraggableEquipmentMarker(this.equipmentUpdate)
            }
        },
        setDefaultValues: function (equipment) {
            if (!this.areaId) {
                this.showAlert(this.$t('areas.invalid_area'))
                return undefined
            } else {
                equipment.area = {id: this.areaId}
            }
            if (equipment.name === '') {
                this.showAlert(this.$t('equipment.invalid_name'))
                return undefined
            }
            if (!equipment.type) {
                this.showAlert(this.$t('equipment.invalid_type'))
                return undefined
            }
            const areaPolygon = this.getAreaPolygon(this.selectedArea)
            const polygon = isPointInPolygon({latitude: equipment.location.y, longitude: equipment.location.x}, areaPolygon)
            if (!polygon) {
                this.showAlert(this.$t('equipment.inside_polygon'))
                return undefined
            }
            if (!equipment.location || !equipment.location.x || !equipment.location.y) {
                this.showAlert(this.$t('areas.invalid_location'))
                return undefined
            } else {
                equipment.location = {lat: equipment.location.y, lon: equipment.location.x}
            }
            return equipment
        },
        updateLocation: function (data) {
            this.equipmentUpdate.location.x = data.position.x
            this.equipmentUpdate.location.y = data.position.y
        },
        setLocation: function (data) {
            this.equipmentUpdate.location.x = data.lng
            this.equipmentUpdate.location.y = data.lat
            this.$refs.equipmentMap.getMap().removeMapMarker(this.equipmentUpdate.id, this.EQUIPMENT)
            this.$refs.equipmentMap.getMap().addDraggableEquipmentMarker(this.equipmentUpdate)
        },
        submitEquipment: function () {
            const jsonEquipment = this.setDefaultValues(this.jsonToEquipment(this.equipmentUpdate))
            if (jsonEquipment !== undefined) {
                this.loading = true
                var url = this.areaEditEquipmentUrl
                if (this.equipmentUpdate.id < 1) {
                    url = this.areaEquipmentUrl
                }
                let formData = new FormData()
                if (this.equipmentPhotoFile !== null) {
                    formData.append('photo', this.equipmentPhotoFile)
                }
                this.restPostWithFile(url, jsonEquipment, formData, this.success, this.fail)
            }
        },

        success: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },

        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        },

        setCurrentLocation: function () {
            if (navigator.geolocation) {
                this.fetchingLocation = true
                navigator.geolocation.getCurrentPosition(pos => {
                    this.equipmentUpdate.location.y = parseFloat(pos.coords.latitude).toFixed(6)
                    this.equipmentUpdate.location.x = parseFloat(pos.coords.longitude).toFixed(6)
                    this.fetchingLocation = false
                }, () => {
                    this.fetchingLocation = false
                    this.showAlert(this.$t('common.alert_location_disabled'))
                }, {timeout: 30000, enableHighAccuracy: true})
            }
        },


        setArea: function (area) {
            if (this.selectedArea && this.selectedArea.geometry) {
                this.$refs.equipmentMap.getMap().removePolygon(this.selectedArea.geometry.id)
            }
            if (!area) {
                return
            }
            this.areaId = area.id
            this.selectedArea = area
            this.fetchAreaData()
        },

        fetchAreaData() {
            let params =  {
                area: this.areaId,
                equipment: 0
            }
            this.restFetchParams(this.areaUrl, params, this.handleAreaDetails)
        },

        triggerFileInput() {
            // Trigger the file input to open the file dialog
            this.$nextTick(() => {
                const input = this.$refs.fileInput
                if (input) {
                    input.click()
                }
            })
        },


        onFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.equipmentPhotoFile = file;
            }
        },

        handleAreaDetails(response) {
            if (response && response.data && response.data.length > 0) {
                this.selectedArea.geometry = response.data[0].geometry
                this.drawArea(response.data[0].geometry, response.data[0].color)
            }
        },

        drawArea: function (data, color) {
            const geometry = data.rings
            for (const index in geometry) {
                if (color) {
                    this.$refs.equipmentMap.getMap().drawPolygon(data.id, geometry[index], this.AREA,  color, color, 0.9)
                } else {
                    this.$refs.equipmentMap.getMap().drawPolygon(data.id, geometry[index], this.AREA, '#bcbcbc', '#bcbcbc', 0.9)
                }
            }
            this.$nextTick(() =>  {
                this.$refs.equipmentMap.getMap().zoomToGroup(this.AREA)
            })
        }

    }
}
</script>
<style scoped>
</style>
